// extracted by mini-css-extract-plugin
export default {"promoFeeC":"index_promoFeeC__eX1ny"};